import { z } from 'zod';

import {
  PronunciationEntitySchema,
  PronunciationReplacementSchema,
} from './pronunciations.schema';

const PronunciationFormBaseSchema = PronunciationEntitySchema.omit({
  id: true,
  caseSensitive: true,
  languageCode: true,
  description: true,
  position: true,
  name: true,
}).extend({
  replacement: PronunciationReplacementSchema.max(256).default(''),
  isLast: z.boolean(),
  serverId: z.string().optional(),
  hasChanged: z.boolean().optional(),
  case_sensitive: z.boolean(),
});

const PronunciationOldSchema = PronunciationFormBaseSchema.merge(
  z.object({
    isLast: z.literal(false),
  }),
);

const PronunciationNewSchema = PronunciationFormBaseSchema.partial().merge(
  z.object({
    isLast: z.literal(true),
  }),
);

const PronunciationFormSchema = z.discriminatedUnion('isLast', [
  PronunciationOldSchema,
  PronunciationNewSchema,
]);

export type PronunciationForm = z.infer<typeof PronunciationFormSchema>;

export const PronunciationsFormSchema = z
  .object({
    pronunciations: PronunciationFormSchema.array()
      .min(1, 'Must have at least one element')
      .transform(data =>
        data
          .filter(v => !v.isLast)
          .map(v => ({
            regex: v.regex,
            replacement: v.replacement,
            case_sensitive: v.case_sensitive,
          })),
      ),
  })
  .transform(v => v.pronunciations);

export type PronunciationSchemaProps = z.input<typeof PronunciationsFormSchema>;
export type PronunciationFormProps = z.output<typeof PronunciationsFormSchema>;
